import { render, staticRenderFns } from "./AppConfigFavoriteMenu.vue?vue&type=template&id=71239fb8&"
import script from "./AppConfigFavoriteMenu.vue?vue&type=script&lang=js&"
export * from "./AppConfigFavoriteMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRadio,VRadioGroup,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71239fb8')) {
      api.createRecord('71239fb8', component.options)
    } else {
      api.reload('71239fb8', component.options)
    }
    module.hot.accept("./AppConfigFavoriteMenu.vue?vue&type=template&id=71239fb8&", function () {
      api.rerender('71239fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/AppConfigFavoriteMenu.vue"
export default component.exports